module.exports = __webpack_public_path__ + "img/8.30297256.jpg";